import React from "react";
import CourtesyHoldEcommerceBenefits from "./CourtesyHoldEcommerceBenefits";
import ECommerceBenefits, { ECommerceBenefitsProps } from "./ECommerceBenefits";
import { cruiseIsWaitlist } from "src/utils/cruise";
import { useECommerceCourtesyHoldStatus } from "src/ssc-api/useECommerceCourtesyHoldStatus";
import { CruisePriceAndOffersV2Response } from "@silversea-ssc/dotcom-api-types/CruisePriceAndOffersV2";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";

type Props = {
  prices: CruisePriceAndOffersV2Response | undefined;
  cruiseCode: string;
  ecommerceStatus: ECommerceStatus | undefined;
} & ECommerceBenefitsProps;

const MaybeECommerceBenefits: React.FC<Props> = ({
  prices,
  cruiseCode,
  title,
  benefits,
  ecommerceStatus
}) => {
  const isWaitslist = cruiseIsWaitlist(prices);
  const status = useECommerceCourtesyHoldStatus(cruiseCode, isWaitslist);

  const isCourtesyHoldActive = status.type === "enabled";

  if (!isCourtesyHoldActive)
    return (
      <ECommerceBenefits key="fallback" title={title} benefits={benefits} />
    );

  return (
    <CourtesyHoldEcommerceBenefits
      key="variant-b"
      days={status.expiration.days}
      ecommerceStatus={ecommerceStatus}
    />
  );
};

export default MaybeECommerceBenefits;
